import React, { useEffect } from 'react';
import { Box } from '@mui/material';
import { X } from 'lucide-react';

const MobileAudioPlayer = ({ 
  audioUrl, 
  audioFilename, 
  onClose, 
  audioElementRef
}) => {

  useEffect(() => {
    // If the audio is already loaded, make sure it's paused when component unmounts
    return () => {
      if (audioElementRef.current) {
        audioElementRef.current.pause();
      }
    };
  }, [audioElementRef]);
  
  return (
    <Box
      sx={{
        position: 'fixed',
        bottom: 0,
        left: 0,
        right: 0,
        backgroundColor: 'background.paper',
        borderTopLeftRadius: '10px',
        borderTopRightRadius: '10px',
        padding: 2,
        paddingBottom: 3,
        zIndex: 11,
        display: 'flex',
        flexDirection: 'column',
        boxShadow: '0px -3px 16px 0px rgba(0, 0, 0, 0.20)',
      }}
    >
      {/* Header with close button */}
      <Box sx={{ display: 'flex', justifyContent: 'flex-end', mb: 2 }}>
        <X 
          size={24} 
          onClick={onClose} 
          style={{ cursor: 'pointer' }} 
        />
      </Box>
      
      {/* Standard HTML audio player */}
      <audio
        key={audioFilename}
        ref={audioElementRef}
        src={audioUrl}
        controls
        style={{ 
          width: '100%',
          outline: 'none',
          height: '40px'
        }}
      />
    </Box>
  );
};

export default MobileAudioPlayer; 